import { useEffect } from "react";
import useViewport from "../../../Utilities/useViewport";
import TabNav from "./TabNav";
import useTeacherNavStore from "../../../stores/useTeacherNavStore";
import { GetPeriods, GetUnviewedWorkRegistrationCountsByPeriod } from "../../../actions/teacherQueries";

const NavTabsOnlyInClass = [5];

export default function TabNavSelector(props) {
  const { width } = useViewport();
  const breakpoint = 620;
  const isMobile = width < breakpoint;

  const tab = useTeacherNavStore((state) => state.tab);
  const setTab = useTeacherNavStore((state) => state.setTab);
  const handlePostNavTab = (tabNr) => {
    setTab(tabNr);
  };

  const periodsData = GetPeriods(props.level, Number(props.objId));
  const { data: unviewedCountsByPeriod } = GetUnviewedWorkRegistrationCountsByPeriod();

  const aplUnviewedCount = (unviewedCountsByPeriod && periodsData.data)
    ? periodsData.data.reduce((sum, p) => sum + (unviewedCountsByPeriod[p.period.id] || 0), 0)
    : 0;

  useEffect(() => {
    if (props.level !== "Class" && NavTabsOnlyInClass.includes(tab)) {
      setTab(1);
    }
  }, [props.level, tab, setTab]);

  return (
    <TabNav
      level={props.level}
      handlePostNavTab={handlePostNavTab}
      tab={tab}
      isMobile={isMobile}
      aplUnviewedCount={aplUnviewedCount}
    />
  );
}
